import React from 'react'
import CardUI from '../../../widgets/layout/CardUI.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import SelectUI from '../../../widgets/input/SelectUI.js'
import './DistributionPage.css'

const DistributionPageUI = ({ context, errorList, totalDisbursement, accountDisbursedList, accountDisbursedListR,
  invDiscountDisbursedList, purposeDisbursedList, womanLedDisbursedList, onRefreshClick,
  financialYear, financialYearList, onFinancialYearChange, onTypeChange
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_disb_brkp' topnav='accounts'
    headerText='Disbursement Distribution' centered={!accountDisbursedList && !purposeDisbursedList && !errorList}
    page='distribution' onTypeChange={onTypeChange}
  >
    {
      !accountDisbursedList && !accountDisbursedListR && !purposeDisbursedList && !errorList &&
      <SpinnerComponentUI />
    }
    <div>
      {
        accountDisbursedList && accountDisbursedListR && purposeDisbursedList &&
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <span className='g_m_left_100 g_large'><b>Disbursement Distribution</b></span>
            </span>
          }
          right={
            <SelectUI selectedKey={financialYear} optionList={financialYearList} onChange={onFinancialYearChange} placeholder='Financial year' />
          }
        />
      }

      {
        totalDisbursement &&
        <BigNumberUI totalDisbursement={totalDisbursement} />
      }

      {
        purposeDisbursedList && purposeDisbursedList.length !== 0 &&
        <PurposeDisbursementUI
          totalDisbursement={totalDisbursement}
          purposeDisbursedList={purposeDisbursedList}
          onRefreshClick={onRefreshClick}
        />
      }
      {
        accountDisbursedList && accountDisbursedList.length !== 0 &&
        <AccountDisbursementUI
          totalDisbursement={totalDisbursement}
          accountDisbursedList={accountDisbursedList}
          onRefreshClick={onRefreshClick}
          invDisc={false}
          retialDisc={false}
        />
      }
      {
        totalDisbursement && accountDisbursedListR && accountDisbursedListR.length !== 0 &&
        <AccountDisbursementUI
          totalDisbursement={totalDisbursement}
          accountDisbursedList={accountDisbursedListR}
          onRefreshClick={onRefreshClick}
          invDisc={false}
          retialDisc={true}
        />
      }
      {
        totalDisbursement && invDiscountDisbursedList &&
        invDiscountDisbursedList.length !== 0 &&
        <AccountDisbursementUI
          totalDisbursement={totalDisbursement}
          accountDisbursedList={invDiscountDisbursedList}
          onRefreshClick={onRefreshClick}
          invDisc={true}
          retialDisc={false}
        />
      }
      {
        womanLedDisbursedList && womanLedDisbursedList.length !== 0 &&
        <WomanLedDisbursementUI
          totalDisbursement={totalDisbursement}
          womanLedDisbursedList={womanLedDisbursedList}
          onRefreshClick={onRefreshClick}
        />
      }
      {
        accountDisbursedList && purposeDisbursedList && accountDisbursedList.length === 0 && purposeDisbursedList.length === 0 &&
        womanLedDisbursedList && womanLedDisbursedList.length !== 0 &&
        <div className='g_m_top_50'>
          <EmptyListUI
            context={context}
            createEnabled={false}
            createDisabledMessageLabel='No disbursements yet'
          />
        </div>
      }
    </div>
  </SuperUserHomePageUI>

const BigNumberUI = ({ totalDisbursement }) =>
  <CardUI className='g_m_bottom_100'>
    <div className='g_flex_h'>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{totalDisbursement.outstandingGrandTotalF2}</b></span>
          <span>Assets Under Management (AUM) *</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{totalDisbursement.alltimeGrandTotalF2}</b></span>
          <span>Total Disbursed since Inception *</span>
        </span>
      </div>
    </div>
    <div className='g_muted g_small g_m_top_100 g_text_right'>
      * Includes total limits of receivable financing
    </div>
  </CardUI>

const AccountDisbursementUI = ({ totalDisbursement, accountDisbursedList, invDisc, retialDisc }) =>
  <div>
    <CardUI title={`By ${retialDisc ? 'Retail' : ''} Account (${invDisc ? 'only' : 'excludes'} receivable financing)`} className='g_m_bottom_100'>
      <table>
        <thead>
          <tr>
            <td></td>
            <th className='name'>Account</th>
            <th className='amt g_text_right'>Outstanding Amt</th>
            <th className='pcnt g_text_right'>Share</th>
            <th className='amt g_text_right'>{invDisc ? 'Current Limit' : 'Current Disbursal'}</th>
            <th className='pcnt g_text_right'>Share</th>
            <th className='amt g_text_right'>Including Repaid</th>
            <th className='pcnt g_text_right'>Share</th>
          </tr>
        </thead>
        <tbody>
          {
            accountDisbursedList.map((account, i) =>
              <tr key={i}>
                <td>{i + 1}.</td>
                <td className='g_no_wrap_2'>{account.accountName}</td>
                <td className='g_text_right'>{account.outstandingF2}</td>
                <td className='g_text_right'>{account.outstandingP}</td>
                <td className='g_text_right'>{account.currentDisbursedF2}</td>
                <td className='g_text_right'>{account.currentDisbursedP}</td>
                <td className='g_text_right'>{account.alltimeDisbursedF2}</td>
                <td className='g_text_right'>{account.alltimeDisbursedP}</td>
              </tr>
            )
          }
          {
            retialDisc && !invDisc &&
            <tr>
              <td></td>
              <td className=''><b>Total</b></td>
              <td className='g_text_right'><b>{totalDisbursement.outstandingRetailTotalF2}</b></td>
              <td />
              <td className='g_text_right'><b>{totalDisbursement.currentRetailTotalF2}</b></td>
              <td />
              <td className='g_text_right'><b>{totalDisbursement.alltimeRetailTotalF2}</b></td>
            </tr>
          }
          {
            !invDisc && !retialDisc &&
            <tr>
              <td></td>
              <td className=''><b>Total</b></td>
              <td className='g_text_right'><b>{totalDisbursement.outstandingTotalF2}</b></td>
              <td />
              <td className='g_text_right'><b>{totalDisbursement.currentTotalF2}</b></td>
              <td />
              <td className='g_text_right'><b>{totalDisbursement.alltimeTotalF2}</b></td>
            </tr>
          }
          {
            invDisc && !retialDisc &&
            <tr>
              <td></td>
              <td className=''><b>Total</b></td>
              <td className='g_text_right'><b>{totalDisbursement.invDiscountOSTotalF2}</b></td>
              <td />
              <td className='g_text_right'><b>{totalDisbursement.invDiscountCurrentTotalF2}</b></td>
              <td />
              <td className='g_text_right'><b>{totalDisbursement.invDiscountAlltimeTotalF2}</b></td>
            </tr>
          }
        </tbody>
      </table>
    </CardUI>
  </div>

const PurposeDisbursementUI = ({ totalDisbursement, purposeDisbursedList }) =>
  <div>
    <CardUI title='By Sector' className='g_m_bottom_100'>
      <table>
        <thead>
          <tr>
            <th className='name'>Sector</th>
            <th className='amt g_text_right'>Outstanding Amt</th>
            <th className='pcnt g_text_right'>{' '}</th>
            <th className='amt g_text_right'>Current Disbursal</th>
            <th className='pcnt g_text_right'>{' '}</th>
            <th className='amt g_text_right'>Including Repaid</th>
            <th className='pcnt g_text_right'>{' '}</th>
          </tr>
        </thead>
        <tbody>
          {
            purposeDisbursedList.map((purpose, i) =>
              <tr key={i}>
                <td className='g_no_wrap_2'>{purpose.purpose}</td>
                <td className='g_text_right'>{purpose.outstandingF2}</td>
                <td className='g_text_right'>{purpose.outstandingP}</td>
                <td className='g_text_right'>{purpose.currentDisbursedF2}</td>
                <td className='g_text_right'>{purpose.currentDisbursedP}</td>
                <td className='g_text_right'>{purpose.alltimeDisbursedF2}</td>
                <td className='g_text_right'>{purpose.alltimeDisbursedP}</td>
              </tr>
            )
          }
          <tr>
            <td className=''><b>Total</b></td>
            <td className='g_text_right'><b>{totalDisbursement.purposeOSTotalF2}</b></td>
            <td />
            <td className='g_text_right'><b>{totalDisbursement.purposeCurrentTotalF2}</b></td>
            <td />
            <td className='g_text_right'><b>{totalDisbursement.purposeAlltimeTotalF2}</b></td>
          </tr>
        </tbody>
      </table>
    </CardUI>
  </div>

const WomanLedDisbursementUI = ({ totalDisbursement, womanLedDisbursedList }) =>
  <div>
    <CardUI title={`Women led ( ${((totalDisbursement.womanLedOSTotal / 100) / parseInt(totalDisbursement.outstandingGrandTotalF2.replace(/,/g, ""), 10) * 100).toFixed(2)}  % )`} className='g_m_bottom_100'>
      <table>
        <thead>
          <tr>
            <th className='name'>Account</th>
            <th className='amt g_text_right'>Outstanding Amt</th>
            <th className='pcnt g_text_right'>Share</th>
            <th className='amt g_text_right'>Current Disbursal</th>
            <th className='pcnt g_text_right'>Share</th>
            <th className='amt g_text_right'>Including Repaid</th>
            <th className='pcnt g_text_right'>Share</th>
          </tr>
        </thead>
        <tbody>
          {
            womanLedDisbursedList.map((account, i) =>
              <tr key={i}>
                <td className='g_no_wrap_2'>{account.accountName}</td>
                <td className='g_text_right'>{account.outstandingF2}</td>
                <td className='g_text_right'>{account.outstandingP}</td>
                <td className='g_text_right'>{account.currentDisbursedF2}</td>
                <td className='g_text_right'>{account.currentDisbursedP}</td>
                <td className='g_text_right'>{account.alltimeDisbursedF2}</td>
                <td className='g_text_right'>{account.alltimeDisbursedP}</td>
              </tr>
            )
          }
          <tr>
            <td className=''><b>Total</b></td>
            <td className='g_text_right'><b>{totalDisbursement.womanLedOSTotalF2}</b></td>
            <td />
            <td className='g_text_right'><b>{totalDisbursement.womanLedCurrentTotalF2}</b></td>
            <td />
            <td className='g_text_right'><b>{totalDisbursement.womanLedAlltimeTotalF2}</b></td>
          </tr>
        </tbody>
      </table>
    </CardUI>
  </div>

export default DistributionPageUI
